import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';

import { ClientSections } from '../enums';
import ClientRequestsSection from '../ClientRequestsSection';
import ApprovedClientsSection from '../ApprovedClientsSection';
import ClientDraftsSection from '../ClientDraftsSection';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import useQueryMatch from 'hooks/useQueryMatch';
import { useAppSelector } from 'hooks/useAppSelector';

const DEFAULT_SECTION = ClientSections.Approved;

const getPageSections = (isAdmin?: boolean) => {
  return !isAdmin ? Object.values(ClientSections) : [DEFAULT_SECTION];
};

export default function ClientsPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = queryString.parse(location.search);
  const isAdmin = useAppSelector(isAdminSelector);
  const pageSectionMatch = useQueryMatch(getPageSections(isAdmin));

  useEffect(() => {
    if (!pageSectionMatch) {
      navigate(`${location.pathname}?section=${DEFAULT_SECTION}`, {
        replace: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSectionMatch]);

  const getSection = () => {
    if (isAdmin) {
      switch (query.section) {
        case ClientSections.Approved:
        default:
          return <ApprovedClientsSection isAdmin={isAdmin} />;
      }
    }

    switch (query.section) {
      case ClientSections.Draft:
        return <ClientDraftsSection />;

      case ClientSections.Pending:
        return <ClientRequestsSection isAdmin={isAdmin} />;

      case ClientSections.Approved:
      default:
        return <ApprovedClientsSection isAdmin={isAdmin} />;
    }
  };

  return <>{getSection()}</>;
}
